import { TOPUP_CONFIG_COMMON } from '../../common/const/topup.const'

export const TOPUP_CONFIG = Object.assign({}, TOPUP_CONFIG_COMMON, {
  minTopups: 1,
  maxTopups: 10,
  topupAmounts: [5, 10, 25, 30, 40, 50, 100, 200],
  topupAmountRecommend: 30,
  topupAmountDefault: 30,
  topupAmountMin: 5,
  topupAmountMax: 200
})

export const TOPUP_TEMPLATE = {
  phone: null,
  amount: null,
  amountOther: null,
  isAmountOtherSet: false,
  isPhoneValid: null,
  isPhoneEmpty: true,
  checkPhoneInProgress: false,
  isCheckPhoneStatusValid: null
}
